import Illustration1 from './Illustration-value-1.svg';
import Illustration2 from './Illustration-value-2.svg';
import Illustration3 from './Illustration-value-3.svg';

export default [
    { src: Illustration1, width: 72, height: 72 },
    { src: Illustration2, width: 72, height: 72 },
    { src: Illustration3, width: 72, height: 72 },
];
